<template>
  <div class="container diy-page">
    <v-head></v-head>
    <v-left current="factory"></v-left>
    <div>
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <!-- <el-tab-pane label="品牌" name="brand" v-if="uid == 1"></el-tab-pane>
        <el-tab-pane label="型号" name="model" v-if="uid == 1"></el-tab-pane>
        <el-tab-pane label="材质" name="material" v-if="uid == 1"></el-tab-pane> -->
        <el-tab-pane label="工厂" name="info"></el-tab-pane>
        <el-tab-pane label="款式" name="styles"></el-tab-pane>
        <el-tab-pane label="订单" name="orders"></el-tab-pane>
      </el-tabs>
      <component :is="activeName"></component>
    </div>
  </div>
</template>
<script>
import head from "@/pages/public/_head";
import left from "@/pages/public/_left";

const brand = (resolve) => require(["@/pages/factory/brand/_list"], resolve);
const model = (resolve) => require(["@/pages/factory/model/_list"], resolve);
const material = (resolve) => require(["@/pages/factory/material/_list"], resolve);
const info = (resolve) => require(["@/pages/factory/info/_list"], resolve);
const styles = (resolve) => require(["@/pages/factory/styles/_list"], resolve);
const orders = (resolve) => require(["@/pages/factory/orders/_list"], resolve);

export default {
  components: {
    "v-head": head,
    "v-left": left,
    brand,
    model,
    material,
    info,
    styles,
    orders,
  },
  data() {
    return {
      uid:0,
      activeName: "info",
    };
  },
  methods: {
    handleClick(e) {
    },
  },
  mounted() {
    this.$nextTick(() => {
      var tab = this.getUrlParam('tab')
      if (tab) { 
        this.activeName = tab
      }
    })
    var admin_password = this.getCookie("admin_password");
    if (admin_password === 'b1315E8') {
      this.uid = parseInt(localStorage.getItem("uid"));
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/pages/factory/Index.vue